import {
    LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER,
    LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER,
    LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER,
    LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE,
    LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE, LOAD_STOW_BIN_METRICS_FOR_CLUSTER, LOAD_STOW_BIN_METRICS_FOR_NODE,
    LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER, LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2,
    LOAD_STOW_BAG_METRICS_FOR_CLUSTER
} from "../actions/ClusterActionsV2";
import {getNodeResourceDataMap} from "../Utility";
import {LOAD_STOW_CART_METRICS_FOR_CLUSTER, LOAD_STOW_CART_METRICS_FOR_NODE} from "../actions/ClusterActions";

/**
 * Initial state of the system.
 */

const initialState = {
    loading: false,
    minOfWorkMetricsMap: {},
    stowPackageMetricsMap: {},
    stowBinMetricsMap: {},
    stowCartMetricsMap: {},
    stowBinMetricsMapForStowV2: {},
    stowBagMetricsMap: {},
    inductPackageMetricsMap: {},
    stowAssociateMetricsMap: {},
    nodeResourceData: {},
    totalStowPackageMetrics: {},
    totalStowBinMetrics: {},
    totalInductPackageMetrics: {},
    totalStowAssociateMetrics: {},
    nodeResourceDataMap: new Map()
}

/**
 * Reducer function for Cluster View that changes state
 * based on the action triggered.
 */
export default function clusterReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_CLUSTER_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_CART_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowCartMetricsMap: action.stowCartMetricsMap
            };
        case LOAD_STOW_CART_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                stowCartMetricsMap: {"Total": {...state.stowCartMetricsMap["Total"], ...action.stowCartMetricsMap["Total"]}}
            };
        case LOAD_STOW_MIN_OF_WORK_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                minOfWorkMetricsMap: action.minOfWorkMetricsMap
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_STOW_BIN_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowBinMetricsMap: action.stowBinMetricsMap
            };
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMap: action.inductPackageMetricsMap
            };
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_CLUSTER:
            return {
                ...state,
                loading: false,
                stowAssociateMetricsMap: action.stowAssociateMetricsMap
            };
        case LOAD_STOW_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowPackageMetrics: {"Total": {...state.totalStowPackageMetrics["Total"], ...action.totalStowPackageMetrics["Total"]}}
            }
        case LOAD_STOW_BIN_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowBinMetrics: action.totalStowBinMetrics
            }
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalInductPackageMetrics: action.totalInductPackageMetrics
            }
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE:
            return {
                ...state,
                loading: false,
                totalStowAssociateMetrics: action.totalStowAssociateMetrics
            }
        case LOAD_METRICS_FOR_CLUSTER_CALL_FAILURE:
            return {
                ...state,
                loading: false
            }
        case LOAD_NODE_RESOURCE_DATA_FOR_CLUSTER :
            return{
                ...state,
                loading: false,
                nodeResourceData: action.nodeResourceData,
                nodeResourceDataMap: getNodeResourceDataMap(action.nodeResourceData)
            }
        case LOAD_STOW_BIN_METRICS_FOR_CLUSTER_FOR_STOW_V2 :
            return {
                ...state,
                loading: false,
                stowBinMetricsMapForStowV2: action.stowBinMetricsMapForStowV2
            }
        case LOAD_STOW_BAG_METRICS_FOR_CLUSTER :
            return {
                ...state,
                loading: false,
                stowBagMetricsMap: action.stowBagMetricsMap
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ClusterReducerV2.js